export default {"src":"/_next/static/image/public/images/green_strips_bkg.55330a306e94af83bda8ecb477cbf5fd.svg","height":52,"width":779};